import logofret from "images/image-logo-removebg.png";

const Logo = () => {
  return (
    <div>
      <img
        className="mx-auto h-28 w-auto"
        src={logofret}
        alt="logo"
      />
    </div>
  )
}

export default Logo